import { x } from '@xstyled/styled-components';
import React, { ComponentProps, useState, useEffect } from 'react';
import ArrowIcon from '~/assets/icons/arrow.svg';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { styled } from '@xstyled/styled-components';
import { useEditorStore } from '~/shell/Store';

const ArrowIconStyled = styled(ArrowIcon)`
  path {
    fill: ${({ fill }) => fill};
  }
`;

const selector = (s: TrainingState) => select(s, 'darkMode');

export const IconButton = (props: ComponentProps<typeof x.button>) => {
  const { contentEditable } = useEditorStore();
  const { darkMode } = useTrainingStore(selector);
  const [isDark, setIsDark] = useState(darkMode === 'dark');

  useEffect(() => {
    if (contentEditable) {
      return;
    }

    if (
      darkMode === 'automatic' &&
      window?.matchMedia?.('(prefers-color-scheme: dark)')?.matches
    ) {
      setIsDark(true);
    } else if (
      darkMode === 'automatic' &&
      window?.matchMedia?.('(prefers-color-scheme: light)')?.matches
    ) {
      setIsDark(false);
    } else {
      setIsDark(darkMode === 'dark');
    }
  }, [darkMode, contentEditable]);

  return (
    <x.button
      w="51px"
      h="51px"
      bg={isDark ? 'rgba(255,255,255,0.2)' : 'rgba(111,111,111,0.2)'}
      borderRadius="50%"
      zIndex={200}
      display="flex"
      alignItems="center"
      justifyContent="center"
      alignSelf="center"
      justifySelf="center"
      transition="all 0.3s ease-out"
      cursor={{ disabled: 'not-allowed' }}
      opacity={{ disabled: '0.5' }}
      {...props}
    >
      <ArrowIconStyled fill={isDark ? '#FFF' : '#000'} />
    </x.button>
  );
};
